module.exports = __webpack_public_path__ + "img/5-small.a4eb6d6e.png";